import { useCallback } from 'react';
import { SupportedLanguage, MultilingualContent, MultilingualArray } from '../types/language';

export const useMultilingual = (currentLanguage: SupportedLanguage) => {
  const getMultilingualContent = useCallback((
    content: MultilingualContent, 
    fallback: string = ''
  ): string => {
    if (!content) return fallback;
    
    // Get the selected language with fallback chain
    return content[currentLanguage] || content['en'] || Object.values(content)[0] || fallback;
  }, [currentLanguage]);

  const getMultilingualArray = useCallback((
    content: MultilingualArray
  ): string[] => {
    if (!content) return [];
    
    // Get the selected language with fallback chain
    const langContent = content[currentLanguage] || content['en'] || Object.values(content)[0];
    return Array.isArray(langContent) ? langContent : [];
  }, [currentLanguage]);

  return {
    getMultilingualContent,
    getMultilingualArray,
  };
};